<template>
	<transition name="fade">
		<div v-if="show">
			<div class="slideover-container" :class="{'open': show}">
				<div class="slideover">
					<section>
					  <!--
					    Slide-over panel, show/hide based on slide-over state.

					    Entering: "transform transition ease-in-out duration-500 sm:duration-700"
					      From: "translate-x-full"
					      To: "translate-x-0"
					    Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
					      From: "translate-x-0"
					      To: "translate-x-full"
					  -->
					  <div class="slideover-child">
					    <div class="slideover-content">
					      <header>
					        <div class="slideover-header">
					          <h2>
					            Panel title
					          </h2>
					          <div class="close-button-container">
					            <button aria-label="Close panel" @click="toggle">
					              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
					              </svg>
					            </button>
					          </div>
					        </div>
					        <div>
					          <p class="slideover-subtext">
					            Lorem, ipsum dolor sit amet consectetur adipisicing elit aliquam ad hic recusandae soluta.
					          </p>
					        </div>
					      </header>
					      <div class="slideover-content-container">
					        <!-- Replace with your content -->
					        <div class="absolute inset-0 py-6 px-4 sm:px-6">
					          <div class="h-full border-2 border-dashed border-gray-200"></div>
					        </div>
					        <!-- /End replace -->
					      </div>
					    </div>
					  </div>
					</section>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		name: 'slideover',
		data() {
			return {
				show: false,
			}
		},
		methods: {
			toggle() {
				if(this.show) {
					this.show = false;
				} else {
					this.show = true;
				}
			}
		}
	}
</script>